import { useEffect } from "react";

const SITE_NAME = "ProsoftMarketplace";

export const useDocumentMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | ${SITE_NAME}`;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;
    }
  }, [title, description]);
};
